import { render, staticRenderFns } from "./employees-overview.vue?vue&type=template&id=029411a6&"
import script from "./employees-overview.vue?vue&type=script&lang=js&"
export * from "./employees-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports